module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"pageTitle":"Login","pageDesc":"Login to Baianat and have an account for all your services and enjoy the login option on Baianat ventures websites."},"ar":{"pageTitle":"تسجيل الدخول","pageDesc":"سجل الآن على بيانات واحصل على حساب من أجل متابعة الخدمات الخاصة بك وتمتع بالعديد من المميزت أهمها استكشاف مشاريع بيانات."}}')
  delete Component.options._Ctor
}
